import { toIntlLocale } from "@/i18n/to-intl-locale";
import type { ControlListItem } from "@/models/control.model";
import { useCallback, useMemo } from "react";
import { useTranslation } from "react-i18next";

export const useTranslateControlWithParametersV2 = (
  control: ControlListItem,
) => {
  const { t, i18n } = useTranslation();

  const formatCellValue = useCallback(
    (value: string, type: string) => {
      switch (type) {
        case "monetary":
          return control.amount.format(toIntlLocale(i18n.language));
        case "percentage":
          return Intl.NumberFormat(toIntlLocale(i18n.language), {
            style: "percent",
            minimumFractionDigits: 0,
            maximumFractionDigits: 2,
          }).format(Number(value));
        default:
          return value.toString();
      }
    },
    [i18n.language, control.amount],
  );

  const translatedParameters = useMemo(() => {
    return control.parameters.reduce(
      (acc, parameter) => {
        acc[parameter.name] = formatCellValue(parameter.value, parameter.type);
        return acc;
      },
      {} as Record<string, string>,
    );
  }, [control.parameters, formatCellValue]);

  return t(control.control, translatedParameters);
};
